import axiosIns from '@/api/axios';

export const GET_LIST = (params) => {
	return axiosIns.get(`/project-tags?${params}`);
};
export const GET_DETAIL = (id) => {
	return axiosIns.get(`/project-tags/${id}`);
};
export const CREATE = (payload) => {
	return axiosIns.post(`/project-tags`, payload);
};
export const UPDATE = (id, payload) => {
	return axiosIns.put(`/project-tags/${id}`, payload);
};
export const DELETE = (id) => {
	return axiosIns.delete(`/project-tags/${id}`);
};
